if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      // Optional
      loadProductFirst: true,
    },
  };
}

(function () {
  BoostPFS.inject(this);

 ProductGridItem.prototype.compileTemplate = function (data) {
    /*** Prepare data ***/
    if (!data) data = this.data;
    var images = data.images_info;
    
    // Custom Bedlinen Inventory Override
    var isBedlinen = data.tags.some(function(tag) { return tag.toLowerCase() === 'epos:sub-category:bedlinen'; });
    var customAvailable = data.available;
    if (isBedlinen) {
      customAvailable = false;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          if (!data.variants[i].inventory_management || data.variants[i].inventory_quantity > 4) {
            customAvailable = true;
            break;
          }
        }
      }
    }

    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !customAvailable; // Check a product is out of stock using our custom logic
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        var vAvailable = data['variants'][i].available;
        // Apply the same custom rule to find the first *truly* available variant
        if (isBedlinen && data['variants'][i].inventory_management && data['variants'][i].inventory_quantity <= 4) {
          vAvailable = false;
        }
        if (vAvailable) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Discount Tags: Search for discount tags
    let discountTag = data.tags.find(element => element.toLowerCase().includes("discount:"));
    let displayWasIsPrices = false;
    let adjustedPrice = "";
    let disc = '';
    let discountedAmount = '';
    if (discountTag) {
      // Find discount percentage, save as a number
      disc = parseInt( discountTag.toLowerCase().split("discount: ")[1].split("%")[0] );
      let discText = disc + "% off";
      discountedAmount = data.price_min * disc / 100;
      adjustedPrice = data.price_min - discountedAmount;

      if ( disc >= 50) {
        displayWasIsPrices = true;
      } else if ( disc >= 25) {
        displayWasIsPrices = true;
      } else if ( disc >= 20) {
        displayWasIsPrices = true;
      } else if ( disc >= 15) {
        displayWasIsPrices = true;
      } else if ( disc >= 10) {
        displayWasIsPrices = true;
      } else {
        displayWasIsPrices = false;
      }
    }    

    var cheapest_variant = firstVariant;
    for (var i = 0; i < data.variants.length; i++) {
      if (parseFloat(cheapest_variant.price) > parseFloat(data.variants[0].price)) {
        cheapest_variant = data.variants[0];
      }
    }

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Variables for WhishList Button
    let wishlistIcon = '<svg width="200" height="200" viewBox="0 0 200 200" fill="none"><path d="M175.196 71.9467C175.106 70.7267 175.056 69.6367 174.886 68.6067C174.756 67.5667 174.616 66.5867 174.396 65.5867C174.296 65.0867 174.196 64.5767 174.096 64.0567C173.966 63.5367 173.836 63.0067 173.696 62.4467C173.576 61.9667 172.986 59.8167 172.656 58.7667C170.346 51.2867 166.796 46.2867 166.796 46.2867C165.016 43.7667 163.486 42.3267 163.016 41.8967C161.466 40.4567 160.046 39.5067 159.176 38.9667C158.576 38.5967 156.496 37.3467 153.466 36.3867C153.236 36.3167 152.426 36.0667 151.336 35.8067C148.576 35.1667 146.426 35.0767 145.036 35.0267C144.596 35.0067 142.876 34.9467 140.596 35.1167C138.926 35.2467 137.266 35.4667 135.626 35.7567C133.346 36.1567 131.546 36.6167 130.746 36.8367C124.736 38.4767 119.686 41.8767 115.586 44.6267C112.566 46.6467 110.706 48.2567 110.276 48.6167C109.466 49.2967 108.776 49.9167 108.186 50.4667C107.576 51.0267 107.126 51.4467 106.756 51.7867C105.926 52.5367 105.346 53.0767 105.256 53.1567C104.496 53.8567 103.036 55.3267 100.076 58.6167C97.1861 55.3167 95.7561 53.8467 94.9861 53.1567C94.8961 53.0767 94.3061 52.5367 93.4861 51.7867C93.1161 51.4567 92.6661 51.0367 92.0561 50.4667C91.4661 49.9167 90.776 49.2967 89.966 48.6167C89.536 48.2567 87.676 46.6567 84.656 44.6267C80.566 41.8767 75.5061 38.4767 69.4961 36.8367C68.6961 36.6167 66.8961 36.1567 64.6161 35.7567C62.9861 35.4767 61.326 35.2467 59.646 35.1167C57.376 34.9467 55.646 35.0167 55.206 35.0267C53.816 35.0767 51.666 35.1667 48.906 35.8067C47.806 36.0667 46.996 36.3167 46.776 36.3867C43.746 37.3467 41.6661 38.5967 41.0661 38.9667C40.1961 39.5067 38.776 40.4567 37.226 41.8967C36.766 42.3267 35.2361 43.7767 33.4461 46.2867C33.4461 46.2867 29.896 51.2867 27.586 58.7667C27.266 59.8167 26.666 61.9567 26.546 62.4467C26.406 63.0067 26.276 63.5367 26.146 64.0567C26.046 64.5767 25.946 65.0867 25.846 65.5867C25.636 66.5867 25.486 67.5667 25.356 68.6067C25.196 69.6367 25.136 70.7367 25.046 71.9467C24.926 74.9467 25.0661 77.0667 25.1761 78.3467C25.4961 82.1867 26.0161 85.3167 26.8261 88.7467C27.6661 92.1867 28.8061 95.9867 31.1861 100.787C32.8361 104.117 35.0461 107.627 37.4961 110.927C39.9461 114.227 42.576 117.357 45.016 120.247C47.926 123.707 49.3961 125.427 51.5561 127.757C52.3761 128.637 58.846 135.607 64.286 139.957C65.916 141.257 70.3661 144.667 71.0561 145.177C71.6461 145.617 71.706 145.667 72.836 146.507C73.956 147.357 76.126 149.027 81.096 152.457C87.376 156.737 88.0461 156.987 90.4261 158.687C93.9461 161.147 95.7361 162.327 95.7361 162.327C95.7361 162.327 96.7961 163.777 99.3861 164.777C99.3961 164.787 99.4261 164.807 99.4361 164.807C99.6961 164.957 99.926 164.997 100.106 164.987C100.286 164.997 100.516 164.957 100.776 164.807C100.786 164.807 100.806 164.787 100.826 164.777C103.426 163.777 104.476 162.327 104.476 162.327C104.476 162.327 106.266 161.147 109.786 158.687C112.166 156.977 112.836 156.727 119.116 152.457C124.086 149.037 126.256 147.357 127.376 146.507C128.496 145.667 128.566 145.617 129.156 145.177C129.846 144.657 134.296 141.257 135.926 139.957C141.366 135.597 147.836 128.637 148.656 127.757C150.816 125.427 152.276 123.707 155.196 120.247C157.636 117.357 160.256 114.227 162.716 110.927C165.166 107.617 167.376 104.117 169.026 100.787C171.406 95.9867 172.546 92.1767 173.386 88.7467C174.196 85.3167 174.726 82.1867 175.036 78.3467C175.176 77.0667 175.326 74.9467 175.196 71.9467ZM170.156 86.6067C169.286 90.2067 168.336 92.7067 167.356 94.7367C166.756 95.9667 166.166 97.0867 165.526 98.2667C164.766 99.6167 163.956 101.047 162.906 102.767C161.726 104.687 160.686 106.777 159.326 108.627C158.626 109.577 157.916 110.507 157.366 111.617C156.756 112.867 155.906 113.957 155.106 115.077C154.306 116.197 153.446 117.257 152.546 118.277C151.816 119.117 150.916 120.147 149.926 121.297C148.896 122.407 147.776 123.627 146.646 124.857C144.256 127.457 141.456 130.237 140.076 131.567C137.116 134.457 131.856 139.047 125.356 143.637C118.266 148.637 103.756 158.877 100.356 160.147C100.316 160.167 100.236 160.197 100.146 160.227C100.056 160.197 99.9761 160.167 99.9361 160.147C96.5361 158.877 82.0161 148.637 74.9361 143.637C68.4261 139.047 63.176 134.457 60.216 131.567C58.846 130.227 56.046 127.447 53.646 124.857C52.506 123.627 51.3861 122.407 50.3661 121.297C49.3761 120.157 48.4761 119.117 47.7461 118.277C46.8461 117.247 45.9761 116.197 45.1861 115.077C44.3861 113.957 43.5361 112.877 42.9261 111.617C42.3761 110.507 41.676 109.577 40.966 108.627C39.596 106.767 38.5661 104.687 37.3861 102.767C36.3361 101.057 35.526 99.6267 34.766 98.2667C34.126 97.0867 33.5361 95.9667 32.9361 94.7367C31.9561 92.7067 31.0061 90.2067 30.1361 86.6067C29.3161 83.0167 28.506 78.3267 28.716 72.0867C28.766 71.2767 28.8161 69.8767 28.9961 68.5467C29.1061 67.2167 29.3761 65.9667 29.4461 65.4267C30.0361 62.2267 30.9861 59.1167 32.2361 56.1467C32.5761 55.3867 32.8661 54.7167 33.1261 54.1267C33.4161 53.5367 33.6661 53.0267 33.8861 52.5667C34.3261 51.6667 34.6761 51.0167 34.9961 50.4367C35.6561 49.2867 36.146 48.3867 37.486 46.8067C39.156 44.9167 40.1661 44.1567 41.4361 43.3567C41.7561 43.1567 42.0861 42.9467 42.4461 42.7067C42.8261 42.5067 43.246 42.2867 43.726 42.0267C44.186 41.7567 44.7461 41.5267 45.3761 41.2467C45.9861 40.9367 46.7361 40.6967 47.5561 40.3867C50.5061 39.3967 52.1461 39.1767 53.8161 38.9067C54.4961 38.8167 55.1861 38.7267 55.9961 38.6767C57.9361 38.5567 59.446 38.6767 60.596 38.7867C61.446 38.8667 63.3761 39.0667 65.8861 39.6367C67.0461 39.8967 69.556 40.5167 72.286 41.6067C73.766 42.1967 78.1661 44.3067 82.5661 47.6467C87.6461 51.4967 94.546 59.9367 97.346 63.1767C97.796 63.7067 98.856 64.9367 100.086 64.8067C101.006 64.7167 101.876 63.8767 103.056 62.7467C103.646 62.1767 104.046 61.7167 104.046 61.7167C112.806 51.5267 117.706 47.6467 117.706 47.6467C122.306 44.0067 126.416 42.2367 127.986 41.6067C130.716 40.5167 133.236 39.8967 134.386 39.6367C136.886 39.0667 138.826 38.8667 139.676 38.7867C140.826 38.6767 142.326 38.5567 144.276 38.6767C145.086 38.7267 145.776 38.8167 146.456 38.9067C148.126 39.1767 149.776 39.3967 152.716 40.3867C153.546 40.6967 154.286 40.9367 154.896 41.2467C155.526 41.5267 156.086 41.7567 156.546 42.0267C157.026 42.2767 157.446 42.4967 157.826 42.7067C158.196 42.9367 158.526 43.1567 158.836 43.3567C160.106 44.1567 161.116 44.9167 162.786 46.8067C164.126 48.3867 164.616 49.2867 165.276 50.4367C165.596 51.0167 165.946 51.6667 166.386 52.5667C166.606 53.0267 166.856 53.5367 167.146 54.1267C167.406 54.7167 167.706 55.3867 168.036 56.1467C169.296 59.1167 170.236 62.2267 170.826 65.4267C170.896 65.9667 171.166 67.2167 171.276 68.5467C171.456 69.8667 171.496 71.2767 171.556 72.0867C171.786 78.3267 170.976 83.0167 170.156 86.6067Z" fill="black"/></svg>';
    let wishlistFilledIcon = '<svg width="200" height="200" viewBox="0 0 200 200" fill="none"><path d="M175.196 71.9467C175.106 70.7267 175.056 69.6367 174.886 68.6067C174.756 67.5667 174.616 66.5867 174.396 65.5867C174.296 65.0867 174.196 64.5767 174.096 64.0567C173.966 63.5367 173.836 63.0067 173.696 62.4467C173.576 61.9667 172.986 59.8167 172.656 58.7667C170.346 51.2867 166.796 46.2867 166.796 46.2867C165.016 43.7667 163.486 42.3267 163.016 41.8967C161.466 40.4567 160.046 39.5067 159.176 38.9667C158.576 38.5967 156.496 37.3467 153.466 36.3867C153.236 36.3167 152.426 36.0667 151.336 35.8067C148.576 35.1667 146.426 35.0767 145.036 35.0267C144.596 35.0067 142.876 34.9467 140.596 35.1167C138.926 35.2467 137.266 35.4667 135.626 35.7567C133.346 36.1567 131.546 36.6167 130.746 36.8367C124.736 38.4767 119.686 41.8767 115.586 44.6267C112.566 46.6467 110.706 48.2567 110.276 48.6167C109.466 49.2967 108.776 49.9167 108.186 50.4667C107.576 51.0267 107.126 51.4467 106.756 51.7867C105.926 52.5367 105.346 53.0767 105.256 53.1567C104.496 53.8567 103.036 55.3267 100.076 58.6167C97.1861 55.3167 95.7561 53.8467 94.9861 53.1567C94.8961 53.0767 94.3061 52.5367 93.4861 51.7867C93.1161 51.4567 92.6661 51.0367 92.0561 50.4667C91.4661 49.9167 90.776 49.2967 89.966 48.6167C89.536 48.2567 87.676 46.6567 84.656 44.6267C80.566 41.8767 75.5061 38.4767 69.4961 36.8367C68.6961 36.6167 66.8961 36.1567 64.6161 35.7567C62.9861 35.4767 61.326 35.2467 59.646 35.1167C57.376 34.9467 55.646 35.0167 55.206 35.0267C53.816 35.0767 51.666 35.1667 48.906 35.8067C47.806 36.0667 46.996 36.3167 46.776 36.3867C43.746 37.3467 41.6661 38.5967 41.0661 38.9667C40.1961 39.5067 38.776 40.4567 37.226 41.8967C36.766 42.3267 35.2361 43.7767 33.4461 46.2867C33.4461 46.2867 29.896 51.2867 27.586 58.7667C27.266 59.8167 26.666 61.9567 26.546 62.4467C26.406 63.0067 26.276 63.5367 26.146 64.0567C26.046 64.5767 25.946 65.0867 25.846 65.5867C25.636 66.5867 25.486 67.5667 25.356 68.6067C25.196 69.6367 25.136 70.7367 25.046 71.9467C24.926 74.9467 25.0661 77.0667 25.1761 78.3467C25.4961 82.1867 26.0161 85.3167 26.8261 88.7467C27.6661 92.1867 28.8061 95.9867 31.1861 100.787C32.8361 104.117 35.0461 107.627 37.4961 110.927C39.9461 114.227 42.576 117.357 45.016 120.247C47.926 123.707 49.3961 125.427 51.5561 127.757C52.3761 128.637 58.846 135.607 64.286 139.957C65.916 141.257 70.3661 144.667 71.0561 145.177C71.6461 145.617 71.706 145.667 72.836 146.507C73.956 147.357 76.126 149.027 81.096 152.457C87.376 156.737 88.0461 156.987 90.4261 158.687C93.9461 161.147 95.7361 162.327 95.7361 162.327C95.7361 162.327 96.7961 163.777 99.3861 164.777C99.3961 164.787 99.4261 164.807 99.4361 164.807C99.6961 164.957 99.926 164.997 100.106 164.987C100.286 164.997 100.516 164.957 100.776 164.807C100.786 164.807 100.806 164.787 100.826 164.777C103.426 163.777 104.476 162.327 104.476 162.327C104.476 162.327 106.266 161.147 109.786 158.687C112.166 156.977 112.836 156.727 119.116 152.457C124.086 149.037 126.256 147.357 127.376 146.507C128.496 145.667 128.566 145.617 129.156 145.177C129.846 144.657 134.296 141.257 135.926 139.957C141.366 135.597 147.836 128.637 148.656 127.757C150.816 125.427 152.276 123.707 155.196 120.247C157.636 117.357 160.256 114.227 162.716 110.927C165.166 107.617 167.376 104.117 169.026 100.787C171.406 95.9867 172.546 92.1767 173.386 88.7467C174.196 85.3167 174.726 82.1867 175.036 78.3467C175.176 77.0667 175.326 74.9467 175.196 71.9467ZM170.156 86.6067C169.286 90.2067 168.336 92.7067 167.356 94.7367C166.756 95.9667 166.166 97.0867 165.526 98.2667C164.766 99.6167 163.956 101.047 162.906 102.767C161.726 104.687 160.686 106.777 159.326 108.627C158.626 109.577 157.916 110.507 157.366 111.617C156.756 112.867 155.906 113.957 155.106 115.077C154.306 116.197 153.446 117.257 152.546 118.277C151.816 119.117 150.916 120.147 149.926 121.297C148.896 122.407 147.776 123.627 146.646 124.857C144.256 127.457 141.456 130.237 140.076 131.567C137.116 134.457 131.856 139.047 125.356 143.637C118.266 148.637 103.756 158.877 100.356 160.147C100.316 160.167 100.236 160.197 100.146 160.227C100.056 160.197 99.9761 160.167 99.9361 160.147C96.5361 158.877 82.0161 148.637 74.9361 143.637C68.4261 139.047 63.176 134.457 60.216 131.567C58.846 130.227 56.046 127.447 53.646 124.857C52.506 123.627 51.3861 122.407 50.3661 121.297C49.3761 120.157 48.4761 119.117 47.7461 118.277C46.8461 117.247 45.9761 116.197 45.1861 115.077C44.3861 113.957 43.5361 112.877 42.9261 111.617C42.3761 110.507 41.676 109.577 40.966 108.627C39.596 106.767 38.5661 104.687 37.3861 102.767C36.3361 101.057 35.526 99.6267 34.766 98.2667C34.126 97.0867 33.5361 95.9667 32.9361 94.7367C31.9561 92.7067 31.0061 90.2067 30.1361 86.6067C29.3161 83.0167 28.506 78.3267 28.716 72.0867C28.766 71.2767 28.8161 69.8767 28.9961 68.5467C29.1061 67.2167 29.3761 65.9667 29.4461 65.4267C30.0361 62.2267 30.9861 59.1167 32.2361 56.1467C32.5761 55.3867 32.8661 54.7167 33.1261 54.1267C33.4161 53.5367 33.6661 53.0267 33.8861 52.5667C34.3261 51.6667 34.6761 51.0167 34.9961 50.4367C35.6561 49.2867 36.146 48.3867 37.486 46.8067C39.156 44.9167 40.1661 44.1567 41.4361 43.3567C41.7561 43.1567 42.0861 42.9467 42.4461 42.7067C42.8261 42.5067 43.246 42.2867 43.726 42.0267C44.186 41.7567 44.7461 41.5267 45.3761 41.2467C45.9861 40.9367 46.7361 40.6967 47.5561 40.3867C50.5061 39.3967 52.1461 39.1767 53.8161 38.9067C54.4961 38.8167 55.1861 38.7267 55.9961 38.6767C57.9361 38.5567 59.446 38.6767 60.596 38.7867C61.446 38.8667 63.3761 39.0667 65.8861 39.6367C67.0461 39.8967 69.556 40.5167 72.286 41.6067C73.766 42.1967 78.1661 44.3067 82.5661 47.6467C87.6461 51.4967 94.546 59.9367 97.346 63.1767C97.796 63.7067 98.856 64.9367 100.086 64.8067C101.006 64.7167 101.876 63.8767 103.056 62.7467C103.646 62.1767 104.046 61.7167 104.046 61.7167C112.806 51.5267 117.706 47.6467 117.706 47.6467C122.306 44.0067 126.416 42.2367 127.986 41.6067C130.716 40.5167 133.236 39.8967 134.386 39.6367C136.886 39.0667 138.826 38.8667 139.676 38.7867C140.826 38.6767 142.326 38.5567 144.276 38.6767C145.086 38.7267 145.776 38.8167 146.456 38.9067C148.126 39.1767 149.776 39.3967 152.716 40.3867C153.546 40.6967 154.286 40.9367 154.896 41.2467C155.526 41.5267 156.086 41.7567 156.546 42.0267C157.026 42.2767 157.446 42.4967 157.826 42.7067C158.196 42.9367 158.526 43.1567 158.836 43.3567C160.106 44.1567 161.116 44.9167 162.786 46.8067C164.126 48.3867 164.616 49.2867 165.276 50.4367C165.596 51.0167 165.946 51.6667 166.386 52.5667C166.606 53.0267 166.856 53.5367 167.146 54.1267C167.406 54.7167 167.706 55.3867 168.036 56.1467C169.296 59.1167 170.236 62.2267 170.826 65.4267C170.896 65.9667 171.166 67.2167 171.276 68.5467C171.456 69.8667 171.496 71.2767 171.556 72.0867C171.786 78.3267 170.976 83.0167 170.156 86.6067Z" fill="#4A4B52"/><path d="M171 58.5C152.2 16.9 116.5 43.8333 101 62.5C57.0504 18.1004 34.6876 41.3335 28.9998 58.5C16.9998 106.5 71.9998 147.5 101 162C132.166 144.833 189.8 100.1 171 58.5Z" fill="#4A4B52" stroke="#4A4B52"/></svg>';
    var itemWishlistHtml = '<button data-with-epi="true" class="swym-button swym-collection-button swym-add-to-wishlist-view-product product_'+data.id+'" data-swaction="addToWishlist" data-product-id="'+data.id+'" data-variant-id="'+data.variants[0].id+'" data-product-url="https://foxford-ireland.myshopify.com{{itemUrl}}">';
    itemWishlistHtml += wishlistIcon + wishlistFilledIcon + '</button>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
    
    // Variables for <product-block-atc>
    var isMultiVariant = data['variants']?.length > 1;
    var addToCartButtonText = soldOut ? theme.strings.products_variant_no_stock : theme.strings.products_product_add_to_cart;
    var addedToCartText = theme.strings.products_product_added_to_cart;
    var hiddenWhenMultiVariant = isMultiVariant ? 'hidden' : '';
    var hiddenWhenIsNotMultiVariant = isMultiVariant ? '' : 'hidden';
    var disabledWhenSoldOut = soldOut ? 'disabled="true"' : '';
    var firstProductOptionName = data.options[0];
    itemHtml = itemHtml.replace(/{{addToCartButtonText}}/g, addToCartButtonText);
    itemHtml = itemHtml.replace(/{{addedToCartText}}/g, addedToCartText);
    itemHtml = itemHtml.replace(/{{hiddenWhenMultiVariant}}/g, hiddenWhenMultiVariant);
    itemHtml = itemHtml.replace(/{{hiddenWhenIsNotMultiVariant}}/g, hiddenWhenIsNotMultiVariant);
    itemHtml = itemHtml.replace(/{{disabledWhenSoldOut}}/g, disabledWhenSoldOut);
    itemHtml = itemHtml.replace(/{{firstProductOptionName}}/g, firstProductOptionName);
    
    // Product Options for <product-block-atc>
    let itemOptListHtml = '';
    let first_available_variant = '';
    data.variants.forEach(variant => {
      // checks
      let checked = "";
      let isDisabled = "";
      let isUnavailable = "";
      if (!first_available_variant && variant.available) {
        first_available_variant = variant.id;
        checked = " checked ";
      }
      if (!variant.available) {
        isDisabled = " disabled ";
        isUnavailable = " is-unavailable";
      }

      let optId = 'product_form_id_' + data.id + '--' + variant.id;
      var optHtml = '' +
      '<div class="opt-block">' +
      '    <input class="opt-btn' + isUnavailable + '" type="radio" name="id" id="'+ optId +'" value="' + variant.id + '" ' + isDisabled + checked + '>' +
      '    <label class="opt-label" for="' + optId + '" title="' + variant.id + '">' +
      '        <span class="opt-label__text">' + variant.option1 + '</span>' +
      '    </label>' +
      '</div>';

      itemOptListHtml += optHtml;
    });
    itemHtml = itemHtml.replace(/{{itemOptListHtml}}/g, itemOptListHtml);




    // Add label
    var itemLabelHtml = '';
    var labels = []; // Array to store multiple labels

    // Check for "new" label conditions
    if (boostPFSConfig.custom.prod_new_show) {
      if (boostPFSConfig.custom.prod_new_method == 'date') {
        var now_s = new Date().getTime();
        var pub_s = new Date(data.published_at).getTime();
        var diff_days = (now_s - pub_s) / (1000 * 86400);

        if (diff_days < boostPFSConfig.custom.prod_new_limit_int) {
          labels.push({
            text: boostPFSConfig.label.new_in,
            cssClassSuffix: 'new-in'
          });
        }
      } else if (boostPFSConfig.custom.prod_new_method == 'tag') {
        if (data.tags.indexOf('New') !== -1) {
          labels.push({
            text: boostPFSConfig.label.new_in,
            cssClassSuffix: 'new-in'
          });
        }
      } else if (data.collections.length > 0) {
        var collections_handle = data.collections.map(function (value) { return value.handle });
        for (var i = 0; i < collections_handle.length; i++) {
          var split_collection_handle = collections_handle[i].split('-');
          if (split_collection_handle.indexOf('new') !== -1) {
            labels.push({
              text: boostPFSConfig.label.new_in,
              cssClassSuffix: 'new-in'
            });
          }
        }
      }
    }

    // Check for "sale" label conditions
    if (boostPFSConfig.custom.prod_sale_show && displayWasIsPrices) {
      if (boostPFSConfig.custom.prod_reduction_type == 'percent') {
        labels.push({
          text: disc + '% off',
          cssClassSuffix: 'sale'
        });
      } else {
        var amount = Utils.formatMoney(discountedAmount);
        labels.push({
          text: 'save ' + amount,
          cssClassSuffix: 'sale'
        });
      }
    }

    // Check for tag-based labels
    if (data.tags.includes('tag:limited-availability')) {
      labels.push({
        text: boostPFSConfig.label.limited_availability,
        cssClassSuffix: 'limited-availability'
      });
    }
    if (data.tags.includes('tag:bestseller')) {
      labels.push({
        text: boostPFSConfig.label.bestseller,
        cssClassSuffix: 'bestseller'
      });
    }

    // Build the HTML for all labels
    if (labels.length > 0) {
      itemLabelHtml += '<div class="product-label-container">';
      labels.forEach(function (label) {
        itemLabelHtml +=
          '<span class="product-label product-label--' + label.cssClassSuffix +'">' +
            '<span>' + label.text + '</span>' +
          '</span>';
      });
      itemLabelHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add class
    var itemFixedWidthClass = boostPFSConfig.custom.thumb_variable_width ? 'variable-width' : boostPFSTemplate.fixedWidthClass;
    itemHtml = itemHtml.replace(/{{itemFixedWidthClass}}/g, itemFixedWidthClass);
    var itemHasThumbnailClass = data['images'].size > 1 ? boostPFSTemplate.hasThumbnailClass : '';
    itemHtml = itemHtml.replace(/{{itemHasThumbnailClass}}/g, itemHasThumbnailClass);
    var aspect_ratio = 1;
    if (images.length > 0) {
      aspect_ratio = images[0]['width'] / images[0]['height'];
    }
    var itemStyle = '';
    if (boostPFSConfig.custom.thumb_variable_width) {
      itemStyle += '<style type="text/css">' +
        '.product-block[data-product-id="{{itemId}}"] .block-inner .image-cont .rimage-outer-wrapper {' +
        'width: ' + Math.floor(aspect_ratio * boostPFSConfig.custom.prod_thumb_height) + 'px;' +
        '}' +
        '@media (max-width: 767px) {' +
        '.product-block[data-product-id="{{itemId}}"] .block-inner .image-cont .rimage-outer-wrapper {' +
        'width: ' + Math.floor(aspect_ratio * 180) + 'px;' +
        '}' +
        '}' +
        '</style>';
    }
    itemHtml = itemHtml.replace(/{{itemStyle}}/g, itemStyle);

    // Add Thumbnail
    var images = data.images_info;
    var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0].src, '480x') : boostPFSConfig.general.no_image_url;
    var itemThumbLargeUrl = images.length > 0 ? Utils.optimizeImage(images[0].src, '1024x1024') : boostPFSConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemThumbLargeUrl}}/g, itemThumbLargeUrl);

    var itemImages = '';
    var aspect_ratios_same = true;
    var hoverClass = '';
    var firstRatio = null;
    if (images.length > 0) {
      itemImages += '<div class="product-block__image product-block__image--primary product-block__image--active" data-media-id="' + images[0].id + '">';
      itemImages += buildImageItem(images[0]);
      itemImages += '</div>';
      firstRatio = images[0].width / images[0].height;
      for (var i = 0; i < data.images.length; i++) {
        if (data.images[0].width / data.images[0].height != firstRatio) {
          aspect_ratios_same = false;
          break;
        }
      }
      if (aspect_ratios_same) {
        hoverClass = ' image-cont--same-aspect-ratio';
      }
    }
    // Add Flip image
    var itemDotsHtml = '';
    if (boostPFSConfig.custom.prod_thumb_hover_image && images.length > 1) {
      firstRatio = images[0].width / images[0].height;
      for (var i = 1; i < images.length; i++) {
        itemImages += '<div class="product-block__image product-block__image--secondary ';
        if (i === 1) {
          itemImages += 'product-block__image--show-on-hover';
        }
        itemImages += ' rimage-wrapper lazyload--placeholder" data-media-id="' + images[i].id + '" data-image-index="' + i + '">';
        itemImages += '<div class="lazyload rimage-background"' +
          'data-lazy-bgset-src="' + Utils.optimizeImage(images[1].src) + '"' +
          'data-lazy-bgset-aspect-ratio="' + firstRatio + '"' +
          'data-sizes="auto"' +
          'data-parent-fit="contain" style="background-image: url(\'' + Utils.optimizeImage(images[i].src, '360x') + '\');"></div>';
        itemImages += '</div>';
      }
      itemDotsHtml += '<div class="product-block__image-dots" aria-hidden="true"><div class="product-block__image-dot product-block__image-dot--active"></div><div class="product-block__image-dot"></div>';
      if (images.length > 2) {
        itemDotsHtml += '<div class="product-block__image-dot product-block__image-dot--more"></div>';
      }
      itemDotsHtml += '</div>';
      hoverClass += ' image-cont--with-secondary-image ';
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);
    itemHtml = itemHtml.replace(/{{hoverClass}}/g, hoverClass);
    itemHtml = itemHtml.replace(/{{itemDots}}/g, itemDotsHtml);

    var itemImagePageButtonsHtml = '';
    itemImagePageButtonsHtml += '<a class="image-page-button image-page-button--previous" href="#" aria-label="' + boostPFSConfig.label.previous + '" tabindex="-1"><svg width="200" height="200" viewBox="0 0 200 200" fill="none"><path d="M132.312 98.32C123.672 92.15 115.032 85.96 106.432 79.73C97.6716 73.38 88.9716 66.94 80.2016 60.58C76.0516 57.57 71.8316 54.67 67.6416 51.72C67.3116 51.49 66.9616 51.3 66.4716 51C65.4716 52.92 66.1816 54.05 67.4816 55C73.6316 59.48 79.8216 63.92 85.9316 68.46C90.5316 71.89 95.0216 75.48 99.5716 78.97C102.622 81.32 105.612 83.76 108.782 85.94C116.072 90.94 123.482 95.76 130.772 100.78C130.802 100.8 130.822 100.81 130.852 100.83C127.082 103.48 123.292 106.1 119.572 108.81C110.812 115.17 102.122 121.62 93.3616 127.98C84.7716 134.22 76.1416 140.41 67.5016 146.59C66.5616 147.26 65.3916 147.75 66.4616 149.1C67.2716 150.12 67.9916 149.77 69.0416 149.05C76.3216 144.03 83.7316 139.2 91.0116 134.19C94.1816 132.01 97.1616 129.56 100.212 127.21C104.762 123.71 109.242 120.12 113.842 116.68C119.942 112.13 126.122 107.69 132.282 103.2C132.542 103.01 133.322 102.42 133.682 101.4C133.792 101.09 134.042 100.41 133.762 99.7C133.522 99.1 132.992 98.72 132.792 98.58C132.552 98.43 132.342 98.34 132.312 98.32Z" fill="black"/></svg></a>';
    itemImagePageButtonsHtml += '<a class="image-page-button image-page-button--next" href="#" aria-label="' + boostPFSConfig.label.next + '" tabindex="-1"><svg width="200" height="200" viewBox="0 0 200 200" fill="none"><path d="M132.312 98.32C123.672 92.15 115.032 85.96 106.432 79.73C97.6716 73.38 88.9716 66.94 80.2016 60.58C76.0516 57.57 71.8316 54.67 67.6416 51.72C67.3116 51.49 66.9616 51.3 66.4716 51C65.4716 52.92 66.1816 54.05 67.4816 55C73.6316 59.48 79.8216 63.92 85.9316 68.46C90.5316 71.89 95.0216 75.48 99.5716 78.97C102.622 81.32 105.612 83.76 108.782 85.94C116.072 90.94 123.482 95.76 130.772 100.78C130.802 100.8 130.822 100.81 130.852 100.83C127.082 103.48 123.292 106.1 119.572 108.81C110.812 115.17 102.122 121.62 93.3616 127.98C84.7716 134.22 76.1416 140.41 67.5016 146.59C66.5616 147.26 65.3916 147.75 66.4616 149.1C67.2716 150.12 67.9916 149.77 69.0416 149.05C76.3216 144.03 83.7316 139.2 91.0116 134.19C94.1816 132.01 97.1616 129.56 100.212 127.21C104.762 123.71 109.242 120.12 113.842 116.68C119.942 112.13 126.122 107.69 132.282 103.2C132.542 103.01 133.322 102.42 133.682 101.4C133.792 101.09 134.042 100.41 133.762 99.7C133.522 99.1 132.992 98.72 132.792 98.58C132.552 98.43 132.342 98.34 132.312 98.32Z" fill="black"/></svg></a>';
    itemHtml = itemHtml.replace(/{{itemImagePageButtons}}/g, itemImagePageButtonsHtml);

    // Add quick buy button
    var itemQuickBuyHtml = '';
    if (boostPFSConfig.custom.quickbuy_style == 'button') {
      itemQuickBuyHtml += '<a class="btn btn--secondary quickbuy-toggle" href="{{itemUrl}}">' + boostPFSConfig.label.quick_buy + '</a>';
    }else if(boostPFSConfig.custom.quickbuy_style == 'whole'){
      itemQuickBuyHtml += '<a class="btn btn--secondary quickbuy-whole quickbuy-toggle" href="{{itemUrl}}"></a>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickBuy}}/g, itemQuickBuyHtml);

  // Add Find Similar button
    var itemFindSimilarButton = ''; // Completely empty the string
    itemHtml = itemHtml.replace(/{{itemFindSimilarButton}}/g, itemFindSimilarButton);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.show_vendor ? '<div class="vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    itemPriceHtml += '<div class="product-price">';
    if (priceVaries) {
      itemPriceHtml += '<span class="product-price__item product-price__from">' + boostPFSConfig.label.listing + '</span>';
    }
    if (displayWasIsPrices && adjustedPrice > 0) {
      itemPriceHtml += '<span class="product-price__item product-price__amount theme-money ' + (displayWasIsPrices ? 'product-price__amount--on-sale' : '') + '"><span class="money">' + Utils.formatMoney(adjustedPrice, Globals.moneyFormat) + '</span></span>';
      itemPriceHtml += '<span class="product-price__item product-price__compare theme-money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
      // Calculate and display percentage off
      var discountPercentage = Math.round(((data.price_min - adjustedPrice) / data.price_min) * 100);
      itemPriceHtml += '<span class="product-price__item product-price__discount">' + discountPercentage + '% off</span>';
    } else {
      itemPriceHtml += '<span class="product-price__item product-price__amount theme-money ' + (onSale ? 'product-price__amount--on-sale' : '') + '"><span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span></span>';
      if (onSale) {
        itemPriceHtml += '<span class="product-price__item product-price__compare theme-money">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span>';
        // Calculate and display percentage off
        var discountPercentage = Math.round(((data.compare_at_price_min - data.price_min) / data.compare_at_price_min) * 100);
        itemPriceHtml += '<span class="product-price__item product-price__discount">' + discountPercentage + '% off</span>';
      }
    }
    
    if (boostPFSConfig.custom.prod_sold_out_show && soldOut) {
      itemPriceHtml += '<span class="product-price__item price-label price-label--sold-out">' + boostPFSConfig.label.sold_out + '</span>';
    } else if (boostPFSConfig.custom.prod_pre_order_label_show && data.template_suffix == 'preorder') {
      itemPriceHtml += '<span class="product-price__item price-label price-label--preorder">' + boostPFSConfig.label.preorder + '</span>';
    }
    itemPriceHtml += '</div>';

    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 31 ? itemDescription.split(" ").splice(0, 31).join(" ") + '...' : itemDescription.split(" ").splice(0, 31).join(" ");
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add Quick view
    var itemQuickViewHtml = '';
    if (boostPFSConfig.custom.quickbuy_style !== 'off') {
      itemQuickViewHtml += '<div class="quickbuy-container">' +
        '<a href="#" class="close-detail" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a>' +
        '<div class="inner"></div>' +
        '</div>';
    };
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    //Add swatch
    var itemSwatchHtml = '';
    var option_limit = 2;
    var options_to_show = boostPFSThemeConfig.custom.prod_thumb_options_names.replace(' ', '').split(',');
    var fileUrlArray = boostPFSConfig.general.file_url.split('?');

    const allTags = data.tags;
    let colorStyleCode = '';
    let colorStyle = false;
    allTags.forEach(function(tag) {
      if(tag.includes('epos:style-group:')) {
        colorStyleCode = tag;
        colorStyle = true;
      }
    });

    for (var i = 0; i < data.options_with_values.length; i++) {
      var option = data.options_with_values[i];
      if (options_to_show.indexOf(option.label) > -1) {
        var is_swatch = (boostPFSThemeConfig.custom.swatch_enabled && boostPFSThemeConfig.custom.swatch_option_name.indexOf(option.label) !== -1) ? true : false;
        itemSwatchHtml += '<div class="product-block-options';
        if (is_swatch) itemSwatchHtml += ' product-block-options--swatch';
        itemSwatchHtml += '" data-swatch="' + Utils.escape(option.label) + '">';
        itemSwatchHtml += '<div class="product-block-options__inner">';
        if (data.options_with_values.length == 1) {
          for (var j = 0; j < data.variants.length; j++) {
            var variant = data.variants[j];
            var optionTitle = variant.options[0];
            var value = false;
            for (var n = 0; n < option.values.length; n++) {
              if (option.values[n].title === optionTitle) {
                value = option.values[n];
                break;
              }
            }
            var imageId = 0;
            for (var n = 0; n < images.length; n++) {
              if (images[n].position == value.image) {
                imageId = images[n].id;
                break;
              }
            }

            if (typeof variant != 'undefined' && value != false) {
              itemSwatchHtml += '<div class="option-selector__btns--custom" data-id="' + data.id+ '" data-stylecode="' + colorStyleCode + '"></div>';
              itemSwatchHtml += '<span class="product-block-options__item product-block-options__item--notcustom';
              if (!variant.available) itemSwatchHtml += ' product-block-options__item--unavailable';
              if (j > option_limit && is_swatch) itemSwatchHtml += ' product-block-options__item--truncated';
              if (is_swatch) itemSwatchHtml += ' lazyload';
              itemSwatchHtml += '" data-swatch="' + Utils.escape(value.title.toLowerCase()) + '" ';
              if (imageId > 0) itemSwatchHtml += ' data-media="' + imageId + '"';
              if (is_swatch) {
                if (boostPFSThemeConfig.custom.swatch_images) {
                  itemSwatchHtml += ' data-bgset="' + fileUrlArray[0] + Utils.slugify(value.title.toLowerCase()) + '_48x48_crop_center.png?v=' + fileUrlArray[1] + '" >';
                } else {
                  var fileUrl = fileUrlArray[0] + Utils.slugify(value.title.toLowerCase()) + '_48x48_crop_center.png?v=' + fileUrlArray[1];
                  itemSwatchHtml += ' style="background-image: url(' + fileUrl + ');">';
                }

              }
              itemSwatchHtml += '<span class="product-block-options__item__text">' + Utils.escape(value.title) + '</span>';
              itemSwatchHtml += '</span>';
            }
          }
          if (data.variants.length > option_limit && is_swatch) {
            var remaining = option.values.length - option_limit - 1;
            itemSwatchHtml += '<span class="product-block-options__more-label">' + boostPFSThemeConfig.label.more_swatches.replace('{{ count }}', remaining) + '</span>';
          }
        } else {
          var index = i + 1;
          for (var j = 0; j < option.values.length; j++) {
            var value = option.values[j];
            var variant = data.variants.find(function (e) { return e['option' + index] == value.title; });
            var imageId = 0;
            for (var n = 0; n < images.length; n++) {
              if (images[n].position == value.image) {
                imageId = images[n].id;
                break;
              }
            }

            if (typeof variant != 'undefined') {
              itemSwatchHtml += '<div class="option-selector__btns--custom" data-id="' + data.id+ '" data-stylecode="' + colorStyleCode + '"></div>';
              itemSwatchHtml += '<span class="product-block-options__item product-block-options__item--notcustom';
              if (!variant.available) itemSwatchHtml += ' product-block-options__item--unavailable';
              if (j > option_limit && is_swatch) itemSwatchHtml += ' product-block-options__item--truncated';
              if (is_swatch) itemSwatchHtml += ' lazyload';
              itemSwatchHtml += '" data-option-item="' + Utils.escape(value.title.toLowerCase()) + '" ';
              if (imageId > 0) itemSwatchHtml += ' data-media="' + imageId + '"';
              if (is_swatch) {
                if (boostPFSThemeConfig.custom.swatch_images) {
                  itemSwatchHtml += ' data-bgset="//cdn.shopify.com/s/files/1/0568/0952/1359/files/' + Utils.slugify(value.title.toLowerCase()) + '_48x48_crop_center.png?v=16614902026360382589" >';
                } else {
                  var fileUrl = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(value.title.toLowerCase()) + '_48x48_crop_center.png';
                  itemSwatchHtml += ' style="background-image: url(' + fileUrl + ');">';
                }

              }
              itemSwatchHtml += '<span class="product-block-options__item__text">' + Utils.escape(value.title) + '</span>';
              itemSwatchHtml += '</span>';
            }
          }
          if (option.values.length > option_limit && is_swatch) {
            var remaining = option.values.length - option_limit - 1;
            itemSwatchHtml += '<span class="product-block-options__more-label">' + boostPFSThemeConfig.label.more_swatches.replace('{{ count }}', remaining) + '</span>';
          }
        }

        itemSwatchHtml += '</div>';
        itemSwatchHtml += '</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>');
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

    return itemHtml;
  }

  function buildImageItem(image, manual, max_height) {
    var itemHtml = '';
    var aspect_ratio = boostPFSThemeConfig.custom.hasOwnProperty('chosen_aspect_ratio') ? boostPFSThemeConfig.custom.chosen_aspect_ratio : '';
    var cover, local_aspect_ratio;

    if (aspect_ratio) {
      cover = true;
      local_aspect_ratio = aspect_ratio;
    } else {
      cover = false;
      local_aspect_ratio = image.width / image.height;
    }

    var max_width;
    if (max_height) {
      max_width = Math.round(max_height * local_aspect_ratio);
    } else {
      max_width = image.width;
    }

    itemHtml += '<div class="rimage-outer-wrapper" ';
    if (!cover) {
      itemHtml += 'style="max-width: ' + max_width + 'px" ';
    }
    itemHtml += '> ';
    itemHtml += '<div class="rimage-wrapper lazyload--placeholder" style="padding-top:' + (1 / local_aspect_ratio * 100) + '%"> ';

    var img_url = bgset(image);

    itemHtml += '<img class="rimage__image lazyload lazyautosizes';
    if (manual) {
      itemHtml += '--manual ';
    }
    itemHtml += ' fade-in';
    if (cover) {
      itemHtml += ' cover';
    }
    itemHtml += '" ';
    itemHtml += 'data-src="' + img_url + '" ';
    itemHtml += 'srcset="' + img_url + '" ';
    itemHtml += 'src="' + image.src + '" ';
    itemHtml += 'data-widths=" [180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ';
    itemHtml += 'data-aspectratio="' + (image.width / image.height) + '" ';
    itemHtml += 'data-sizes="auto " ';
    itemHtml += 'alt="{{itemTitle}}" ';
    if (cover) {
      itemHtml += 'data-parent-fit="cover " ';
    }
    itemHtml += '> ';

    itemHtml += '</div> ';
    itemHtml += '</div> ';

    return itemHtml;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    // Get page info
    if (!totalProduct) totalProduct = this.totalProduct;
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Build page items

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var paramSort = Globals.queryParams.sort || '';
      var sortingArr = Utils.getSortingList();
      var activeSorting = Labels.sorting;
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var activeClass = '';
          if (paramSort == k) {
            activeClass = 'link-dropdown__link--active';
            activeSorting = sortingArr[k];
          }
          sortingItemsHtml += '<a href="#" class="link-dropdown__link ' + activeClass + '" data-value="' + k + '">' + sortingArr[k] + '</a>';
        }
        var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml).replace(/{{activeSorting}}/g, activeSorting);
      }
    }
    return html;
  };

  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + ' a').click(function (event) {
      event.preventDefault();
      // Append "sort" param to url
      // Used to Scroll to the previous position after returning from Product page
      FilterApi.setParam('sort', jQ(this).data('value'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    })
  }

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    /** End Swym integration **/ document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    if (!data){
      data = this.data;

      // custom swatch color for all items using view=tag
      data.forEach(function(item) {
        const allTags = item.tags;
        let colorStyleCode = '';
        let colorStyle = false;

        // save style tag in a var
        // set custom colorstyle as true
        allTags.forEach(function(tag) {
          if(tag.includes('epos:style-group:')) {
            colorStyleCode = tag.replace('/','-');
            colorStyle = true;
          }
        });

        // if custom-swatch exist fetch all products from view tag.json
        if (document.querySelector('.option-selector__btns--custom') && colorStyle) {
          fetch('/collections/all/' + colorStyleCode + '?view=tag.json')
            .then((response) => response.json())
            .then((response) => {
              let swatches = '';
              for (const item of response) {
                let variantName = '';
                id = item.id;
                if (item.variants[0].option2 == '' || item.variants[0].option2 == null) {
                  variantName = item.variants[0].option1;
                } else {
                  variantName = item.variants[0].option2;
                }

                swatches += variantName + '-' + item.id + '-' + item.title + ',';
              }

              // get color list on customize theme -> swatches
              let colors = document.querySelector('[data-colors]').getAttribute('data-colors');
              colors = colors.split('\n');

              const matchColor = (color) => {
                let c = '';
                colors.forEach((item) => {
                  if(item.includes(color)) {
                    item = item.split(':');
                    c = item[0];
                  } else {
                    c = color;
                  }
                });

                return c.toLowerCase().replace(' ','');
              }

              // split swatch list and push match swatches to the matched product
              let swatchColorID = swatches.split(',');
              let swatchArray = [];
              swatchColorID.forEach(function(item) {
                if(document.querySelector('.option-selector__btns--custom[data-stylecode="'+ colorStyleCode +'"]')) {
                  if(item !== '') {
                    swatchArray.push(item);
                  }
                }
              });

              // for all custom swatch color
              // build right structure to display colors
              document.querySelectorAll('.option-selector__btns--custom').forEach(function(option){
                let id = option.getAttribute('data-id');
                let html = '';

                if(swatchArray.length > 1) {
                  for (let i = 0; i < 3; i++) {
                    if(swatchArray[i] != '') {
                      let splitSwatch = swatchArray[i].split('-');
                      html += '<span class="product-block-options__item" data-swatch="' + splitSwatch[0].toLowerCase() + '" data-option-item="'+ splitSwatch[0].toLowerCase() +'">';
                      html += '<span class="product-block-options__item__text">' + splitSwatch[0] + '</span>';
                      html += '</span>';
                    }
                  }

                  if(swatchArray.length > 3) {
                    let swatchCount = swatchArray.length - 3;
                    html += '<span class="option-selector__swatch-count"><a href="/products/' + item.handle + '"> + ' + swatchCount + ' more</a></span>';
                  }

                  document.querySelectorAll('.option-selector__btns--custom[data-stylecode="' + colorStyleCode + '"]').forEach(function(opt){
                    opt.innerHTML = html;
                  });
                }
              })
            })
            .catch((err) => console.log(err));
        }
      });     
    } 
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    jQ('.boost-pfs-filter-total-products').html(data.total_product + ' products');

    if(document.querySelector(".collection-custom-banner")) {
      const customBanner = document.querySelector(".collection-custom-banner");
      const divClone = customBanner.cloneNode(true); // the true is for deep cloning

      var currentPage = parseInt(Globals.queryParams.page);
      if(data.total_product >= 8 && currentPage == 1) {
        document.querySelector('.boost-pfs-filter-products').appendChild(divClone);
        //buildTheme();
      }    
    }
  };

  function bgset(image) {
    var bgset = '';
    if (image) {
      var aspect_ratio = image.width / image.height;
      if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
      if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
      if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
      if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
      if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
      if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
      if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
      if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
      if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
      if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
      if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
      if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
      if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
      if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
      if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
      if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
      if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
      if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
      bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
    }
    return bgset;
  }

  function buildTheme() {
    theme.Sections.register('collection-template', theme.CollectionTemplateSection);
    Shopify.PaymentButton.init();
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }
  }

})();
